import axios from 'axios';
import {configSettings} from '../../shared/configuration/config-settings';

export interface GuestReportExchangeResponse {
  reportId: number;
  title: string;
  description?: string;
  embedUrl: string;
  filters: {
    clientId: number;
    startDate?: string;
    endDate?: string;
  };
  expiresAt: string;
}

export const exchangeGuestReportToken = async (
  token: string,
): Promise<GuestReportExchangeResponse> => {
  const response = await axios.post<GuestReportExchangeResponse>(
    `${configSettings.unified_aws_app_gateway_uri}/report/v2/guest-report/${encodeURIComponent(token)}/exchange`,
  );
  return response.data;
};
